import { render, staticRenderFns } from "./upload-model.vue?vue&type=template&id=7fbbd9f6&scoped=true&"
import script from "./upload-model.ts?vue&type=script&lang=ts&"
export * from "./upload-model.ts?vue&type=script&lang=ts&"
import style0 from "./upload-model.scss?vue&type=style&index=0&id=7fbbd9f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbbd9f6",
  null
  
)

export default component.exports